import { IErrorProps } from "../../models";

interface ErrorHandlingProps {
  errorListGlobal: IErrorProps[]; // Replace any with the actual type of the items in the array
  setOpenDialogNoURLError: (value: boolean) => void;
  setOpenToastError: (value: boolean) => void;
  setOpenDialogServerError: (value: boolean) => void;
  openDialogNoURLError: boolean;
  openToastError: boolean;
  openDialogServerError: boolean;
}
export const setErrorPopupsusingErrorCode = (props: ErrorHandlingProps) => {
  if (
    props.errorListGlobal.some((x) => x.errorCode === undefined) &&
    !props.openDialogNoURLError
  ) {
    props.setOpenDialogNoURLError(true);
  }

  if (
    props.errorListGlobal.some((x) => x.errorCode === 400) &&
    !props.openToastError
  ) {
    props.setOpenToastError(true);
  }
  if (
    props.errorListGlobal.some(
      (x) =>
        x.errorCode !== undefined &&
        x.errorCode !== 400 &&
        x.errorCode !== null &&
        x.errorCode !== 204
    ) &&
    !props.openDialogServerError
  ) {
    props.setOpenDialogServerError(true);
  }
};
